/**
 * Practice state slice - the practice in progress on the home board.
 *
 * Each entry of `moves` is indexed by its ply in game.history() (the line's own moves stay undefined):
 * {
 *   ply, actor: "user" | "rival", san, uci, fenBefore, label ("6...Bg7"),
 *   verdict: { status: "pending" | "rated" | "unavailable", code, loss, accuracy, bestSan, bestUci, source },
 *   insight: { code, text, tone } | null,
 *   stats: { db, mine },   // what the insight was built from, for the details view
 *   xp, combo, hinted
 * }
 */
export const practiceSlice = {
    // idle: nothing loaded | ready: line on the board, waiting for the first move | playing
    // offbook: the last move left the book, waiting for the user to take it back or stop
    // finished: results on screen | locked: a visitor must log in to start another practice
    status: "idle",
    line: null,          // { source: "catalog" | "user", slug, id, name, color, idea, moves, uci, fen, level, eco }
    hasTree: false,      // catalog tree loaded: sparring moves, stats and verdicts need no network
    moves: [],
    revision: 0,         // bumped on every change of `moves`, for subscribers
    ownMoves: 0,
    combo: 0,
    bestCombo: 0,
    xp: 0,
    accuracy: null,
    offbook: null,       // { rarity: "rare" | "unknown" | "paused" } while status is "offbook"
    notice: null,        // something the user has to know to go on (Lichess not connected, not answering)
    hintUci: null,       // move being hinted on the board
    isRetry: false,      // replaying from a slip of the previous practice: for learning, never recorded
    resumable: null,     // { id, name, slug, source, color, ownMoves, savedAt } of the practice left
                         // in the middle in this tab, for the button that offers it back
    result: null,        // summary shown on the results panel once finished
    opening: null,       // opening name of the current position, when the book knows it
};
